export default __webpack_public_path__ + "static/media/settings.d011eaa7.svg";